module.exports = __webpack_public_path__ + "img/icon6-1.f8344b74.svg";